document.addEventListener('DOMContentLoaded', function() {
  initBundleProductsSwiper();
});

function initBundleProductsSwiper() {
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper library not loaded. Single product view will be used.');
    return;
  }

  const sections = document.querySelectorAll('.bundleProductsSection');
  
  sections.forEach(section => {
    const swiperContainer = section.querySelector('.bundleProductsSection_swiper');
    
    if (swiperContainer && swiperContainer.querySelector('.swiper-wrapper')) {
      try {
        new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: '.bundleProductsSection_pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            480: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
          },
        });
      } catch (error) {
        console.error('Error initializing Swiper:', error);
      }
    }
  });
}
